const normalizeIdentity = (value) => String(value || '').trim().toLowerCase();
const normalizeDateOnly = (value) => String(value || '').slice(0, 10);

export const REQUIRED_SCHEDULE_TIME_MESSAGE =
  'Preencha o horário inicial e final antes de adicionar integrantes.';
export const UNAVAILABLE_MEMBER_MESSAGE = 'Este integrante está indisponível neste horário.';

const parseTimeToMinutes = (value) => {
  const match = String(value || '').match(/^(\d{1,2}):(\d{2})/);
  if (!match) return null;
  const hours = Number(match[1]);
  const minutes = Number(match[2]);
  if (!Number.isFinite(hours) || !Number.isFinite(minutes)) return null;
  return hours * 60 + minutes;
};

const getScheduleWindow = (schedule = {}) => {
  const start = parseTimeToMinutes(schedule.start_time);
  const end = parseTimeToMinutes(schedule.end_time);

  if (start === null) return null;
  if (end === null || end <= start) return { start, end: start, isPoint: true };
  return { start, end, isPoint: false };
};

const scheduleTimesOverlap = (leftSchedule = {}, rightSchedule = {}) => {
  const left = getScheduleWindow(leftSchedule);
  const right = getScheduleWindow(rightSchedule);

  if (!left || !right) return true;

  if (left.isPoint && right.isPoint) return left.start === right.start;
  if (left.isPoint) return left.start >= right.start && left.start < right.end;
  if (right.isPoint) return right.start >= left.start && right.start < left.end;

  return left.start < right.end && right.start < left.end;
};

const isSamePersonInSchedule = (selectedMember, scheduleMember, sameTeam = false) => {
  if (!selectedMember || !scheduleMember) return false;

  const selectedMemberId = selectedMember.member_id || null;
  const scheduleMemberId = scheduleMember.member_id || null;
  if (selectedMemberId && scheduleMemberId && selectedMemberId === scheduleMemberId) return true;
  if (selectedMemberId && scheduleMemberId && selectedMemberId !== scheduleMemberId) return false;

  const selectedEmail = normalizeIdentity(selectedMember.member_email);
  const scheduleEmail = normalizeIdentity(scheduleMember.member_email);
  if (selectedEmail && scheduleEmail && selectedEmail === scheduleEmail) return true;
  if (selectedEmail && scheduleEmail && selectedEmail !== scheduleEmail) return false;

  if (sameTeam && selectedMember.id && scheduleMember.id && selectedMember.id === scheduleMember.id) {
    return true;
  }

  const selectedName = normalizeIdentity(selectedMember.name);
  const scheduleName = normalizeIdentity(scheduleMember.name);
  return !!selectedName && selectedName === scheduleName;
};

export const getScheduleTimeLabel = (schedule = {}) => {
  if (!schedule.start_time) return 'horário não informado';
  return schedule.end_time ? `${schedule.start_time} - ${schedule.end_time}` : schedule.start_time;
};

export const hasRequiredScheduleTimes = (schedule = {}, extraTimeField = null) => {
  if (!schedule.start_time || !schedule.end_time) return false;
  if (extraTimeField && !schedule[extraTimeField]) return false;
  return true;
};

export const validateRequiredScheduleTimes = ({
  schedule = {},
  toast,
  extraTimeField = null,
  extraTimeLabel = 'horário adicional'
}) => {
  if (!schedule.start_time || !schedule.end_time) {
    toast?.error(REQUIRED_SCHEDULE_TIME_MESSAGE);
    return false;
  }

  if (extraTimeField && !schedule[extraTimeField]) {
    toast?.error(`Preencha o ${extraTimeLabel} antes de adicionar integrantes.`);
    return false;
  }

  if (schedule.end_time <= schedule.start_time) {
    toast?.error('O horário final deve ser depois do horário inicial.');
    return false;
  }

  return true;
};

export const findScheduleMemberConflict = ({
  selectedMember,
  formSchedule,
  editingSchedule,
  currentTeamType,
  schedulePools
}) => {
  for (const pool of schedulePools) {
    for (const schedule of pool.items || []) {
      if (normalizeDateOnly(schedule.date) !== normalizeDateOnly(formSchedule.date)) continue;
      if (pool.type === currentTeamType && editingSchedule?.id && schedule.id === editingSchedule.id) continue;
      if (!scheduleTimesOverlap(schedule, formSchedule)) continue;

      const exists = (schedule.members || []).some((scheduleMember) =>
        isSamePersonInSchedule(selectedMember, scheduleMember, pool.type === currentTeamType)
      );

      if (exists) {
        return {
          memberName: selectedMember.name || 'Integrante',
          ministry: pool.label,
          scheduleTitle: schedule.title || 'Escala',
          scheduleTime: getScheduleTimeLabel(schedule)
        };
      }
    }
  }

  return null;
};
